// stores/route.js
import { defineStore } from 'pinia';
import type { RouteLocationNormalizedLoadedGeneric } from 'vue-router';

export const useRouteStore = defineStore('route', {
  state: () => ({
    lastRoute: null as RouteLocationNormalizedLoadedGeneric | null,
  }),
  actions: {
    setLastRoute(route: RouteLocationNormalizedLoadedGeneric) {
      this.lastRoute = route;
    },
  },
});
